"use strict";

const mlist = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

var currencyFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
});

if(typeof require === 'function') {
  var Handlebars = require('handlebars'),
    logger = require('./logging')('Handlebars-helper'),
    moment = require('moment');
}

function getProgress(completed, isProduction) {
  var currentDate = new Date();
  var currentDateInGMT = new Date(currentDate.valueOf() + currentDate.getTimezoneOffset() * 60000);
  if (!(completed instanceof Date)) {
    completed = new Date(completed);
  }
  var completedInGMT = new Date(completed.valueOf() + completed.getTimezoneOffset() * 60000);
  var timeDiff = Math.abs(currentDateInGMT.getTime() - completedInGMT.getTime());

  if (isProduction) {
    var diffHours = Math.ceil(timeDiff / (1000 * 3600));
    if (diffHours <= 8) {
      return '';
    } else if (diffHours <= 16) {
      return 'twoPointFive';
    } else {
      return 'threePointFive';
    }
  } else {
    var diffMinutes = Math.ceil(timeDiff / (1000 * 60));
    if (diffMinutes <= 1) {
      return '';
    } else if (diffMinutes <= 2) {
      return 'twoPointFive';
    } else {
      return 'threePointFive';
    }
  }
}

function getETA(completed) {
  if (!(completed instanceof Date)) {
    completed = new Date(completed);
  }
  var eta = completed;
  do {
    eta = new Date(eta.valueOf() + (1000 * 3600 * 24));
  } while (eta.getDay() === 0 || eta.getDay() === 6);
  return eta;
}

function cleanRegex(regex) {
  if (!regex) {
    throw new Error('Failed to compile regex');
  }

  //python flag modifiers aren't supported by js
  if (regex.indexOf('(?i)') === 0) {
    regex = regex.replace('(?i)', '');
  }

  var regexEvaluated,
    flags;

  //regex is supplied by msf it might be invalid
  //it might compile to regex object, as long as source of regex is
  //api server it is "safe"
  try {
    regexEvaluated = eval(regex);
  } catch (e) {}

  if (regexEvaluated instanceof RegExp) {
    if (regexEvaluated.global) { // Evaluated regex fits the bill
      return regexEvaluated;
    }

    regex = regexEvaluated.source;
    flags = regexEvaluated.flags || '';
    flags += 'g';
  } else {
    flags = 'g';
  }

  return new RegExp(regex, flags)
}

function emailContainsCodified(email) {
  return email.substr(email.lastIndexOf('@')).includes('codified');
}

(function(helpers) {
  if(typeof module !== 'undefined') {
    module.exports = helpers;
    return;
  }

  Object.keys(helpers).forEach(function(helper) {
    Handlebars.registerHelper(helper, helpers[helper]);
  });
})({
  caps : function(context) {
    return context.toUpperCase();
  },
  json : function(context) {
    return JSON.stringify(context);
  },
  levelToVersion : function(context) {
    var LEVEL_TO_VERSION = {
      23 : 'Android 6.0',
      22 : 'Android 5.1',
      21 : 'Android 5.0',
      20 : 'Android 4.4W',
      19 : 'Android 4.4',
      18 : 'Android 4.3',
      17 : 'Android 4.2, 4.2.2',
      16 : 'Android 4.1, 4.1.1',
      15 : 'Android 4.0.3, 4.0.4',
      14 : 'Android 4.0, 4.0.1, 4.0.2',
      13 : 'Android 3.2',
      12 : 'Android 3.1.x',
      11 : 'Android 3.0.x',
      10 : 'Android 2.3.3',
      9 : 'Android 2.3',
      8 : 'Android 2.2.x',
      7 : 'Android 2.1.x',
      6 : 'Android 2.0.1',
      5 : 'Android 2.0',
      4 : 'Android 1.6',
      3 : 'Android 1.5',
      2 : 'Android 1.1',
      1 : 'Android 1.0'
    };

    if(LEVEL_TO_VERSION[context]) {
      return LEVEL_TO_VERSION[context];
    }

    return 'Android';
  },
  ifobject : function(v, options) {
    if(typeof v === 'object') {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  highlight : function(text, regex) {
    var r;

    if (regex) {
      try {
        r = cleanRegex(regex);
      } catch (e) {
        logger.error('Failed to compile regex', {
          regex : regex
        });

        return text;
      }
    } else {
      return text;
    }
    
    var matcherResult,
      startOfSplit = 0,
      result = '';

    // Global flag is explicitly set; we may traverse string with .exec()
    //
    // This is also necessary because we can't just string split by regex with
    // capturing parentheses, it will add captured group to results:
    //
    //    var text = "Split by an article";
    //    var r = /\b(a|an|the)\b/;
    //    text.split(r);    // yields [ 'Split by ', 'an', ' article' ]
    //
    while ((matcherResult = r.exec(text)) !== null) {
      const indexOfCurrentMatch = matcherResult.index;
      const highlightPart = matcherResult[0];

      if (indexOfCurrentMatch > startOfSplit) { // We have non-highlight part before highlight part
        const nonHighlightPart = text.substring(startOfSplit, indexOfCurrentMatch);
        result += Handlebars.Utils.escapeExpression(nonHighlightPart);
      }

      result += '<span class="code-highlight">' + Handlebars.Utils.escapeExpression(highlightPart) + '</span>';

      startOfSplit = r.lastIndex;
    }

    const nonHighlightPart = text.substring(startOfSplit);
    result += Handlebars.Utils.escapeExpression(nonHighlightPart);

    return new Handlebars.SafeString(result);
  },
  linesTooLong : function(lines, options) {
    if (lines && lines.length > 6000) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    };
  },
  timeAgo : function(context) {
    if(!context) {
      return 'Pending';
    }

    return moment(new Date(context)).fromNow();
  },
  ifMoreThan : function(v1, v2, options) {
    var i1 = parseInt(v1, 10),
      i2 = parseInt(v2, 10);

    if(i1 > i2) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  initials : function(context) {
    if(!context || context === 'Unknown') {
      return 'A';
    }

    var words = (context || 'Unknown').split(/[\s\.]+/),
      buffer = '';

    for (var i = 0; i < words.length; i += 1) {
      if(i === 4) {
        return buffer;
      }

      buffer = buffer + words[i][0];
    }

    return buffer;
  },
  ifneq : function(v1, v2, options) {
    if(v1 !== v2) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  ifeq : function(v1, v2, options) {
    if(v1 === v2) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  ifResultDoesntExist : function(status, options) {
    if(['completed', 'failed', 'pendingVerification'].indexOf(status) === -1) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  ifResultExists : function(status, options) {
    if(['completed', 'failed'].indexOf(status) !== -1) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  formatResultFailure : function(context) {
    if(context.failure && context.failure.message) {
      return context.failure.message;
    }

    return 'Unknown reason';
  },
  year : function() {
    var d = new Date();

    return d.getUTCFullYear();
  },
  resultDate : function(context) {
    if(!context) {
      return 'Pending';
    }

    return moment(new Date(context)).format('HH:mm DD/MM/YYYY');
  },
  dateYear : function(context) {
    if(!context) {
      return '-';
    }

    return moment(new Date(context)).format('YYYY');
  },
  dateMonth : function(context) {
    if(!context) {
      return '-';
    }

    return moment(new Date(context)).format('MMMM');
  },
  dateDate : function(context) {
    if(!context) {
      return '-';
    }

    return moment(new Date(context)).format('Do');
  },
  dateDay : function(context) {
    if(!context) {
      return '-';
    }

    return moment(new Date(context)).format('dddd');
  },
  dateTime : function(context) {
    if(!context) {
      return '-';
    }

    return moment(new Date(context)).format('HH:mm');
  },
  currency : function(amount) {
    return currencyFormatter.format(amount / 100);
  },
  codeFix : function(text, codeFix) {
    if(!codeFix || codeFix.type !== 'replace') {
      return;
    }

    var r;

    try { //regex is supplied by msf it might be invalid
      r = new RegExp(codeFix.replaceRegex, 'gi');
    } catch(e) {
      logger.error('Failed to compile regex', {
        regex : codeFix.replaceRegex
      });

      return text;
    }

    //text is split and matched in two parts so that it can be properly escaped
    //if text would be escaped before matching some highglights might not work(if they
    //contain quotes etc)
    //if text would be escaped after matching then highlight span element would get escaped
    var parts = text.split(r),
      matches = text.match(r) || [];

    if(parts.length === 0 || matches.length === 0) {
      logger.warn('Regex didnt find any matches', {
        regex : codeFix.replaceRegex,
        lines : text
      });
    }

    var result = parts.reduce(function(s, p, i) {
      s = s + Handlebars.Utils.escapeExpression(p);

      if(matches[i]) {
        s = s + '<span class="code-fix-highlight">' + Handlebars.Utils.escapeExpression(codeFix.replaceValue) + '</span>';
      }

      return s;
    }, '');

    return new Handlebars.SafeString(result);
  },
  ifContainsRule: function(isTrue, ruleSet, rule, options) {
    if(!isTrue) {
      return options.inverse(this);
    }

    if(!Array.isArray(ruleSet)) { //for backward compability
      return options.fn(this);
    }

    if(ruleSet.length === 0) { //empty set means that everything was scanned
      return options.fn(this);
    }

    if(ruleSet.indexOf(rule) !== -1) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  section: function(name, options) {
      if (!this._sections) this._sections = {};
      this._sections[name] = options.fn(this);
      return null;
  },
  ifcontain : function(v1, v2, options) {
    if(v1.indexOf(v2) !== -1) {
      return options.fn(this);
    }

    return options.inverse(this);
  },
  getProgressBarProgress: function(completed, isProduction) {
    return getProgress(completed, isProduction);
  },
  getTwoActive: function(completed, isProduction) {
    var res = getProgress(completed, isProduction);
    return (res === 'twoPointFive' || res === 'threePointFive') ? 'active' : '';
  },
  getThreeActive: function(completed, isProduction) {
    return getProgress(completed, isProduction) === 'threePointFive' ? 'active' : '';
  },
  getETA: function(completed) {
    if (!completed) {
      return 'Any moment now...';
    }
    var eta = getETA(completed);
    // if we're over time then we should let users know that it should be ready soon
    if (new Date() > eta) {
      return 'Any moment now...';
    }

    var dd = eta.getDate();
    var mmm = mlist[eta.getMonth()];
    return dd + ' ' + mmm;
  },
  overTime: function(completed, options) {
    if (new Date() > getETA(completed)) {
      return options.fn(this);
    }
    return options.inverse(this);
  },
  hasPurchased : function(billingHistory) {
    return billingHistory && billingHistory.length > 0 && billingHistory.some(function(entry) {return entry.reason !== 'evaluation'}) ? true : false;
  },
  ifContainsCodified : function(email, options) {
    return emailContainsCodified(email) ? options.fn(this) : options.inverse(this);
  }
});
